import { Button, Ga4EventType, ga4Info, soundManager, SoundType, useGameRuleStore } from '@slot-nx/core'
import hs_info_on_click from '../../../asset/images/menu/info_on_click.png'
import hs_info_on_hover from '../../../asset/images/menu/info_on_hover.png'
import hs_info_on_normal from '../../../asset/images/menu/info_on_normal.png'

import { Assets } from 'pixi.js'

Assets.addBundle('HSRules', {
  hs_info_on_click: { src: hs_info_on_click, loadParser: 'loadTextures' },
  hs_info_on_hover: { src: hs_info_on_hover, loadParser: 'loadTextures' },
  hs_info_on_normal: { src: hs_info_on_normal, loadParser: 'loadTextures' },
})

interface RulesProps {
  x: number
  y: number
  width: number
  height: number
}

export const RulesButton = (props: RulesProps) => {
  return (
    <Button
      name="rules"
      defaultView="hs_info_on_normal"
      hoverView="hs_info_on_hover"
      pressedView="hs_info_on_click"
      x={props.x}
      y={props.y}
      width={props.width}
      height={props.height}
      onPress={() => {
        useGameRuleStore.setState({ isOpened: true })
        soundManager.play(SoundType.buttonConfirm)
        ga4Info.addEvent(Ga4EventType.menu_betting_rules)
      }}

    />
  )
}
